import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryDispatch = createAsyncThunk(
  "inventory/fetchInventoryDispatch",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    type,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    type?: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }

    if (type === "Transfer") {
      const response: any = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Transfer&${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } else if (type === "Allocation") {
      const response: any = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Allocation&${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } else if (type === "Items Request") {
      const response: any = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Item Request&${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } else {
      return {
        data: [],
        rowCount: 0,
      };
    }
    // const response: any = await WarehouseAxios.get(
    //   `/stock/issue-for-packing/list/?${params.toString()}`
    // );
  }
);
export const fetchInvetoryDispatchId = createAsyncThunk(
  "procurement/fetchInvetoryDispatchId",
  async (dispatch_done_id: string, { rejectWithValue }) => {
    try {
      const response: any = await WarehouseAxios.get(
        `/dispatch/${dispatch_done_id}/detail/`
      );

      return response?.data?.data;
    } catch (error: any) {
      console.error("Error fetching PR by ID:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch PR details"
      );
    }
  }
);
